<template src="./UpdateModule.html"></template>
<script>
import SelectFeatureTemplate from "@/components/CommandCellTemplate/SelectFeatureTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("packageModules");

export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      columns: [
        { cell: SelectFeatureTemplate, title: "SELECT", width: "200px" },
        { field: "id", hidden: true, title: "ID" },
        { field: "name", title: "NAME" },
        { field: "type", hidden: true, title: "TYPE" }
      ],
      dataItem: [],
      moduleId: "",
      modulename: this.$store.state.packageModules.editModule.name
    };
  },
  methods: {
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    goToListPage: function() {
      this.$router.push({ name: "PackageModule" });
    },
    getDataOnload: function() {
      this.$store.dispatch("packageModules/getFetaureList");
      this.moduleId = this.$route.params.modId;
    },
    updateModules: function() {
      var inputElements = document.getElementsByClassName("checkBoxcss");
      var checkedValue = [];

      for (var i = 0; i < inputElements.length; ++i) {
        if (inputElements[i].checked) {
          checkedValue.push({
            ID: Number(inputElements[i].value),
            Name: (this.feature.filter(item =>item.id == Number(inputElements[i].value)))[0]?.name
          });
        }
      }
      if (this.modulename != "") {
        if (checkedValue.length > 0) {
          const reqRes = this.$store.dispatch("packageModules/updateModule", {
            Name: this.modulename,
            features: checkedValue,
            id: this.$route.params.modId
          });
          if (reqRes) {
            this.$notify({
              group: "foo",
              title: "Important message",
              text: "Module updated successfully!"
            });
            this.$router.push({ name: "PackageModule", path: "/package" });
          } else {
            this.$notify({
              group: "foo",
              title: "Important message",
              text: "Unable to update module!"
            });
          }
        } else {
          this.$notify({
            group: "foo",
            title: "Important message",
            text: "Select feature!"
          });
        }
      } else {
        this.$notify({
          group: "foo",
          title: "Important message",
          text: "Module name found empty!"
        });
      }
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features
    }),
    total() {
      return this.feature.length;
    },
    items: {
      get: function() {
        // return orderBy(
        console.log('this.feature', this.feature);
        return this.feature.slice(this.skip, this.take + this.skip);
        // this.sort
        //  );
      }
    }
    // feature: function() {
    //   const feature = this.$store.state.features;
    //   return feature;
    // }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>



<style scoped >
.selectInput {
  height: 37px;
  background-color: #f9e4e4;
}
</style>

    